import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import type { IProcedureGetOne } from '../../interfaces/procedureGetOne';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import type { ISupervisionGetOne } from '../../interfaces/supervisionGetOne';
import type { ITask } from '../../interfaces/task';
import { ButtonContainer } from '../common';
import { AddExaminationButton } from './AddExaminationButton';
import { BecomeRequesterButton } from './BecomeRequesterButton';
import { CancelProcedureButton } from './CancelProcedureButton';
import { EditProcedureButton } from './EditProcedureButton';
import { PrintCarePathButton } from './PrintCarePathButton';
import { RemoveProcedureButton } from './RemoveProcedureButton';
import { TakeProcedureAndStartExaminationButton } from './TakeProcedureAndStartExaminationButton';
import { TakeProcedureButton } from './TakeProcedureButton';
import { TakeSupervisionButton } from './TakeSupervisionButton';
import { UpdateSupervisionButton } from './UpdateSupervisionButton';

interface IProcedureReadButtonsProps {
    addExaminationReport?: () => Promise<void>;
    editProcedure?: () => Promise<void>;
    isLastItem: boolean;
    procedure: IProcedureGetOne;
    reloadProcess?: () => Promise<void>;
    removeProcedure?: () => Promise<void>;
    request: IRequestGetOne;
    supervision?: ISupervisionGetOne;
    task?: ITask;
    updateSupervision?: () => Promise<void>;
}

export function ProcedureReadButtons(props: IProcedureReadButtonsProps) {
    const isManager = useSelector((state: IReduxState) => state.authentication.isManager);
    const practitionerId = useSelector((state: IReduxState) => state.authentication.id);

    if (!props.isLastItem || isManager) {
        return null;
    }

    return (
        <ButtonContainer
            alignRight
            buttons={[
                <PrintCarePathButton
                    isLastItem={props.isLastItem}
                    request={props.request}
                />,
                <CancelProcedureButton
                    procedure={props.procedure}
                    removeProcedure={props.removeProcedure}
                    serviceCode={props.request.service.code}
                />,
                <RemoveProcedureButton
                    procedure={props.procedure}
                    removeProcedure={props.removeProcedure}
                    serviceCode={props.request.service.code}
                />,
                <EditProcedureButton
                    editProcedure={props.editProcedure}
                    procedure={props.procedure}
                />,
                <TakeProcedureButton
                    procedure={props.procedure}
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <BecomeRequesterButton
                    procedure={props.procedure}
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <AddExaminationButton
                    addExaminationReport={props.addExaminationReport}
                    request={props.request}
                />,
                <TakeProcedureAndStartExaminationButton
                    addExaminationReport={props.addExaminationReport}
                    procedure={props.procedure}
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <TakeSupervisionButton
                    practitionerId={practitionerId}
                    reloadProcess={props.reloadProcess}
                    supervision={props.supervision}
                    task={props.task}
                />,
                <UpdateSupervisionButton
                    practitionerId={practitionerId}
                    task={props.task}
                    updateSupervision={props.updateSupervision}
                />,
            ]}
        />
    );
}
